import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-graphicGuideConfig",
  "use": "icon-graphicGuideConfig-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-graphicGuideConfig\"><path d=\"M111.502222 0A111.502222 111.502222 0 0 0 0 111.274667V478.435556c0 143.189333 116.736 259.470222 260.152889 259.470222h589.937778a111.502222 111.502222 0 0 0 111.502222-111.274667V259.470222C961.820444 116.451556 845.084444 0 701.553778 0H111.502222z m582.087111 416.028444h-425.528889a48.924444 48.924444 0 1 1 0-97.848888h425.528889a48.924444 48.924444 0 1 1 0 97.848888zM183.523556 794.737778C91.022222 794.737778 20.650667 729.884444 0 670.321778V796.444444a227.555556 227.555556 0 0 0 227.555556 227.555556h506.538666a227.555556 227.555556 0 0 0 227.555556-227.555556v-1.706666H183.523556z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/graphicGuideConfig.svg
// module id = K2XW
// module chunks = 78